import { createFileRoute, Outlet } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/citizens")({
  loader: () => ({ crumb: "Citizens" }),
  component: RouteComponent
})

function RouteComponent() {
  return <Outlet />
}
